import { useCallback, useMemo } from 'react';
import { RackInsideExtension } from '@thive/fddm-types';
import { Switch } from '@mui/material';

import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { areasToFlatCollection, isRackingArea } from '@/modules/floorplanDesign/helpers';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

function InsideExtension() {
  const selectedAreas = useReadSelectedAreas();
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const insideExtension = useMemo(() => {
    const areas = areasToFlatCollection(selectedAreas);
    if (areas.length !== 1) return;
    const area = areas[0];
    if (!isRackingArea(area)) return;

    return area.insideExtension;
  }, [selectedAreas]);

  const onForwardParkingChange = useCallback(
    (newValue: RackInsideExtension['forwardParking']) => {
      const areas = areasToFlatCollection(selectedAreas);
      if (areas.length !== 1) return;
      const area = areas[0];
      if (!isRackingArea(area)) return;

      fddmSvc.setPreference('rackingArea.insideExtension.forwardParking', newValue);
      fddmSvc.updateArea({
        ...area,
        insideExtension: {
          forwardParking: newValue,
        },
      });
    },
    [fddmSvc, selectedAreas],
  );

  if (!insideExtension) return null;

  return (
    <PropertiesLabel i18nkey='interface:properties.area.forward_parking'>
      <Switch
        checked={insideExtension.forwardParking}
        onChange={(_, checked) => onForwardParkingChange(checked)}
      />
    </PropertiesLabel>
  );
}

export default InsideExtension;
